import React, { useState, useCallback, useMemo } from 'react';
import { Typography, Box, Button, useMediaQuery, useTheme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { SelectField } from '../../../../../Components/Field';
import { TypedFormFieldValue } from '../../../../../Components/Form/Form.types';
import { StepProps } from './types';
import { StepButtonBar } from './StepButtonBar';
import EvaluationStepInfo from './EvaluationStepInfo';

const PRIMARY = '#c4122f';

interface Step4ReminderProps extends StepProps {
  reminderOptions: { id: number; name: string }[];
}

const Step4Reminder = ({
  onNext, onBack, onCancel, currentData, reminderOptions, evalutionStepInfo, currentStepName, onUpdateEvalution,
}: Step4ReminderProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

  const deriveSendReminder = () => {
    if (currentData._sendReminder === true) return 'yes';
    if (currentData._sendReminder === false) return 'no';
    if (currentData.Reminder != null) return 'yes';
    return '';
  };

  const [sendReminder, setSendReminder] = useState<string>(deriveSendReminder);
  const [reminderOption, setReminderOption] = useState<number | undefined>(
    currentData.Reminder != null ? currentData.Reminder : undefined,
  );

  const resolveReminderLabel = () => {
    if (currentData._reminderLabel) return currentData._reminderLabel;
    if (currentData.Reminder != null) {
      const matched = reminderOptions.find(o => o.id === currentData.Reminder);
      return matched?.name || '';
    }
    return '';
  };
  const [reminderLabel, setReminderLabel] = useState<string>(resolveReminderLabel);

  const selectOptions = useMemo(() => reminderOptions.map(o => ({ value: o.id, label: o.name })), [reminderOptions]);
  const isValid = sendReminder === 'no' || (sendReminder === 'yes' && reminderOption != null);

  const handleReminderChange = useCallback((val: TypedFormFieldValue<number> | undefined) => {
    if (val) {
      setReminderOption(val.value);
      setReminderLabel(val.label || '');
    } else {
      setReminderOption(undefined);
      setReminderLabel('');
    }
  }, []);

  const handleNext = () => {
    if (!isValid) return;
    onNext({
      _sendReminder: sendReminder === 'yes',
      Reminder: sendReminder === 'yes' ? reminderOption : undefined,
      _reminderLabel: sendReminder === 'yes' ? reminderLabel : undefined,
    });
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* <Typography
            variant="h6"
            style={{
              fontWeight: 600,
              marginBottom: theme.spacing(3),
              lineHeight: 1.4,
              textAlign: 'center',
              fontSize: isMobile ? '16px' : '18px',
            }}
          >
            {formatMessage({ id: 'law-portal.evalution.reminder.yes.no.qus' })}
          </Typography> */}
          <Box style={{ display: 'flex', gap: theme.spacing(1.5), marginBottom: theme.spacing(3), justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="outlined"
              onClick={() => setSendReminder('yes')}
              style={{
                minWidth: '80px', fontWeight: 700, borderColor: PRIMARY,
                color: sendReminder === 'yes' ? '#fff' : PRIMARY,
                background: sendReminder === 'yes' ? PRIMARY : 'transparent',
                fontSize: isMobile ? '12px' : '14px',
              }}
            >
              {formatMessage({ id: 'law-portal.evalution.yes' })}
            </Button>
            <Button
              variant="outlined"
              onClick={() => { setSendReminder('no'); setReminderOption(undefined); setReminderLabel(''); }}
              style={{
                minWidth: '80px', fontWeight: 700, borderColor: PRIMARY,
                color: sendReminder === 'no' ? '#fff' : PRIMARY,
                background: sendReminder === 'no' ? PRIMARY : 'transparent',
                fontSize: isMobile ? '12px' : '14px',
              }}
            >
              {formatMessage({ id: 'law-portal.evalution.no' })}
            </Button>
          </Box>
          {sendReminder === 'yes' && (
            <>
              {/* <Typography
                variant="h6"
                style={{
                  fontWeight: 600,
                  marginBottom: theme.spacing(2),
                  lineHeight: 1.4,
                  textAlign: 'center',
                  fontSize: isMobile ? '16px' : '18px',
                }}
              >
                {formatMessage({ id: 'law-portal.evalution.reminder.date.label' })}
              </Typography> */}
              <Box style={{ maxWidth: '320px', width: '100%' }}>
                <SelectField
                  name="reminder-interval"
                  placeholder={formatMessage({ id: 'utils.select.select' })}
                  options={selectOptions}
                  errorTexts={[]}
                  initialState={reminderOption != null ? { value: reminderOption, label: reminderLabel } : undefined}
                  onChange={handleReminderChange}
                  maxMenuHeight={150}
                />
              </Box>
            </>
          )}
        </div>

        <EvaluationStepInfo evalutionStepInfo={evalutionStepInfo} currentStepName={currentStepName} onUpdate={onUpdateEvalution} />
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleNext}
          nextLabel="form.save.and.back"
          nextDisabled={!isValid}
          formatMessage={formatMessage}
        />
      </Box>
    </div>
  );
};

export default Step4Reminder;